import { render, staticRenderFns } from "./ProductAttributeButton.vue?vue&type=template&id=ffba11e6&scoped=true&"
import script from "./ProductAttributeButton.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeButton.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributeButton.vue?vue&type=style&index=0&id=ffba11e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffba11e6",
  null
  
)

export default component.exports